<template>
    <div id="content">
        <loader v-if="loading"></loader>

        <div class="rounded" id="matrix" v-if="!matrix">
            <b-button variant="dark" size="lg" @click="matrix = true">Matrix</b-button>
        </div>
        <matrix v-else/>
    </div>
</template>

<script>
    import ContentLoader from '../../../components/ContentLoader';
    import Matrix from './components/Matrix';
    import ShowError from '../../../helpers/showError';

    export default {
        name: 'Dashboard',
        data() {
            return {
                data: false,
                loading: true,
                matrix: false
            }
        },
        components: {
            loader: ContentLoader,
            matrix: Matrix,
        },
        methods: {
            async load() {
                try {
                    this.loading = true;
                    //this.data = await GetAdminAnalytics();
                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.loading = false;
                }
            },
        },
        created() {
            this.load();
        },
    }
</script>

<style scoped>
    #matrix {
        margin: 0 auto;
        background: #f1f1f1;
        margin-top: 30px;
        padding: 10% 20%;
        text-align: center;
    }
</style>